import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { permissionLevelEnum } from '../constants';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
    children: ReactNode;
    requiredLevel: keyof typeof permissionLevelEnum;
    redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredLevel, redirectTo = '/' }) => {
    const { user } = useAuth();

    if (user && user.profileId.permsLevel <= permissionLevelEnum[requiredLevel]) {
        return <>{children}</>;
    } else {
        return <Navigate to={redirectTo} replace />;
    }
};

export default ProtectedRoute;
